module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Rectangle_346241914@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FRectangle_346241914%402x.png
// module id = jC59
// module chunks = 93